import React from 'react';
import { Watermark as BaseWatermark } from '@fx-ui/fine-design';
import { authModel } from '../../models';
import { WATERMARK_COLOR, WATERMARK_DENSITY, WatermarkConfig } from '../../interfaces';
import { COLOR_MAP, DARK_COLOR_MAP, DENSITY_MAP } from '@libs/shared';

const WATERMARK_TEXT_MAX_LENGTH = 12;

interface WatermarkProps {
    zIndex?: number;
    id?: string;
    isDarkTheme?: boolean;
    /** 水印配置 */
    config?: WatermarkConfig;
}

const Watermark: React.FC<WatermarkProps> = (props) => {
    const { config, isDarkTheme, ...otherProps } = props;

    const { watermark, isMemberExist, memberNickname, memberUsername } = authModel;

    if (!isMemberExist) {
        return null;
    }

    const getWatermarkProps = () => {
        const {
            enabled,
            color = WATERMARK_COLOR.LIGHT,
            density = WATERMARK_DENSITY.NORMAL
        } = config || watermark || { enabled: false };

        const [width, height] = DENSITY_MAP[density] || DENSITY_MAP[WATERMARK_DENSITY.NORMAL];

        return {
            enable: enabled,
            color:
                (isDarkTheme ? DARK_COLOR_MAP[color] : COLOR_MAP[color]) ||
                COLOR_MAP[WATERMARK_COLOR.LIGHT],
            width,
            height
        };
    };

    const getWatermarkText = () => {
        // 默认水印规则：成员在企业通讯录中的姓名+编号后四位
        const usernameLength = memberUsername.length;

        return (
            memberNickname.substring(0, WATERMARK_TEXT_MAX_LENGTH) +
            memberUsername.substring(usernameLength - 4, usernameLength)
        );
    };

    return <BaseWatermark {...getWatermarkProps()} text={getWatermarkText()} {...otherProps} />;
};

export default Watermark;
